import { connect } from 'react-redux';
import { determineWhichFlow } from '../../../../../flows/DynamicFlow/utilities/helpers';
import {
  getCheckinDateSelection,
  getCheckoutDateSelection,
  getTotalNumberOfNights
} from '../../../../../store/componentStores/Dates/dates.selectors';
import { openModal } from '../../../../../store/componentStores/GlobalModal/globalModal.actions';
import {
  getAdultsCount,
  getKidsAges,
  getKidsCount,
  getNumberOfGuests
} from '../../../../../store/componentStores/Guests/guests.selectors';
import {
  getIsCartActive,
  getIsHighestRatesEnabled,
  getIsTaxOnlyMessage,
  getLoyaltyEarnThresholdNights,
  getPointsMultiplier,
  getTaxAndFeesLabels
} from '../../../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import {
  clearPlanPackages,
  clearSelectedPackages,
  deletePackage,
  upsertPackage
} from '../../../../../store/componentStores/Packages/packages.actions';
import {
  getPackagesGrossTotal,
  getPackagesTaxes,
  getSelectedPackages
} from '../../../../../store/componentStores/Packages/packages.selectors';
import {
  setCartReturnedPageLinkClicked,
  setIsCartOpenClose
} from '../../../../../store/componentStores/Plans/plans.actions';
import {
  clearSelectedSuite,
  pushToDiningPackagesPage,
  pushToPackagesPage,
  pushToPayment,
  updateRateCodes
} from '../../../../../store/componentStores/Suite/suite.actions';
import {
  getParkingFee,
  getPromotionalSavings,
  getRateType,
  getResortFee,
  getRoomAdjustmentTax,
  getSelectedSuite,
  getSuiteGrossTotal,
  getSuiteHeadline,
  getSuiteTaxes,
  getSustainabilityFee,
  getTaxesAndFeesDetailAvailability
} from '../../../../../store/componentStores/Suite/suite.selectors';
import {
  getDueAtCheckInAmount,
  getDueTodayAmount,
  getGrossSummaryTotal,
  getSummaryTotal,
  getValidOfferCode
} from '../../../../../store/reducers';

import isEmpty from 'lodash-es/isEmpty';
import {
  getUserIsLoggedIn,
  getUserLoyaltyOptIn,
  getUserLoyaltyPointsBalance,
  getUserOffers
} from '../../../../../store/componentStores/Account/account.selectors';
import {
  pushToLastVisitedStep,
  resetCartResortLocation,
  setExpiredCart
} from '../../../../../store/componentStores/Cart/cart.actions';
import {
  getCartLastVisitedStep,
  getCartResortLocation,
  getExpiredCart
} from '../../../../../store/componentStores/Cart/cart.selectors';
import {
  getResortLocation,
  getResortLocationUrlParam
} from '../../../../../store/componentStores/CurrentLodge/currentLodge.selectors';
import { getChangeFee } from '../../../../../store/componentStores/ManageReservation/manageReservation.selectors';
import { removeActiveOffer } from '../../../../../store/componentStores/Offer/offer.actions';
import {
  getActiveOffers,
  getEmailActiveOffers,
  getOfferCode
} from '../../../../../store/componentStores/Offer/offer.selectors';
import {
  getCartReturnedPageLinkClicked,
  getIsAPScall,
  getIsCartOpenClose
} from '../../../../../store/componentStores/Plans/plans.selectors';
import { getReservationIdOnAps } from '../../../../../store/componentStores/ReservationDetailsEntity/reservationDetailsEntity.selectors';
import { showLoyalty } from '../../../../../store/reducers';
import { DATE_FORMATS } from '../../../../../utilities/constants';
import { getDateMonthDayFormat } from '../../../../../utilities/dates';
import { getGuestCountLabel } from '../../../../../utilities/guestsUtils';
import { checkIfIsNiagaraProperty } from '../../../../../utilities/navigationUtils';
import { getTaxesAndFees, getTaxesAndFeesDynamic } from '../../../../../utilities/taxes';
import { GwDatesWrapper } from '../../../../_internal_date_/gwDatesWrapper';
import { SUMMARY_CART_VARIATIONS } from '../utilities/constants';
import { Summary } from './Summary';

const getPlanSummaryTotal = (onPaymentPage, state) => {
  return onPaymentPage ? getSummaryTotal(state) : getGrossSummaryTotal(state);
};

const mapStateToProps = (state, { location, variation, flowName }) => {
  const { isModifyFlow } = determineWhichFlow(flowName);

  const { pathname } = location;

  const onPaymentPage = pathname.includes('/payment');
  const avoidCartLogoRender = onPaymentPage;

  const cmpUrls = ['confirmation', /my-reservations\/[\w\d]+/];
  const onCmpPage = cmpUrls.some(keyword => {
    if (keyword instanceof RegExp) {
      return keyword.test(pathname);
    }
    return pathname.includes(keyword);
  });

  const onPlanPage = pathname.includes('/plan');

  const selectedPackages = getSelectedPackages(state.packages);

  const taxAndFeeLabels = getTaxAndFeesLabels(state.lodgeConfig);

  const taxesAndFeesPrices = getTaxesAndFeesDetailAvailability(state.suite);
  // This is added until backend changes are ready
  const taxesAndFees =
    !isEmpty(taxAndFeeLabels) && !isEmpty(taxesAndFeesPrices)
      ? getTaxesAndFeesDynamic(taxAndFeeLabels, taxesAndFeesPrices, getPackagesTaxes(state.packages))
      : getTaxesAndFees(
          getSustainabilityFee(state.suite),
          getPackagesTaxes(state.packages) + getSuiteTaxes(state.suite),
          getResortFee(state.suite),
          getParkingFee(state.suite)
        );

  /* ABCD TEST FOR PARKING FEE */

  const resortLocation = getResortLocation(state.currentLodge);

  return {
    checkIn:
      variation === SUMMARY_CART_VARIATIONS.CART
        ? GwDatesWrapper.format(getCheckinDateSelection(state.dates), DATE_FORMATS.monthDayYear)
        : getDateMonthDayFormat(getCheckinDateSelection(state.dates)),
    checkOut:
      variation === SUMMARY_CART_VARIATIONS.CART
        ? GwDatesWrapper.format(getCheckoutDateSelection(state.dates), DATE_FORMATS.monthDayYear)
        : getDateMonthDayFormat(getCheckoutDateSelection(state.dates)),
    currentSelectedPackages: selectedPackages,
    dueTodayAmount: getDueTodayAmount(state),
    dueAtCheckinAmount: getDueAtCheckInAmount(state),
    guestCountText: getGuestCountLabel(getAdultsCount(state.guests), getKidsCount(state.guests), variation),
    hasAdditionalCharges: taxesAndFees && taxesAndFees.length > 0,
    hasSelectedPackages: selectedPackages && selectedPackages.length > 0,
    isNiagaraProperty: checkIfIsNiagaraProperty(resortLocation),
    rateType: getRateType(state.suite),
    numberOfGuests: getNumberOfGuests(state.guests),
    numberOfNights: getTotalNumberOfNights(state.dates),
    onPaymentPage: onPaymentPage,
    packagesTotal: getPackagesGrossTotal(state.packages),
    promoCode: getValidOfferCode(state),
    promotionalSavings: getPromotionalSavings(state.suite),
    suiteTitle: getSuiteHeadline(state.suite),
    suiteTotal: getSuiteGrossTotal(state.suite),
    summaryTotal: getPlanSummaryTotal(onPaymentPage, state),
    taxesAndFees: taxesAndFees,
    pointsBalance: getUserLoyaltyPointsBalance(state.account),
    loyaltyOptIn: getUserLoyaltyOptIn(state.account),
    showLoyalty: showLoyalty(state),
    userOffers: getUserOffers(state.account),
    activeOffers: getActiveOffers(state.offer),
    emailActiveOffers: getEmailActiveOffers(state.offer),
    isUserAuthenticated: getUserIsLoggedIn(state.account),
    getPointsMultiplier: getPointsMultiplier(state.lodgeConfig),
    roomAdjustmentTax: getRoomAdjustmentTax(state),
    offerCode: getOfferCode(state.offer),
    resortLocation,
    selectedSuite: getSelectedSuite(state.suite),
    resortLocationUrlParam: getResortLocationUrlParam(state.currentLodge),
    onCmpPage,
    onPlanPage,
    isApsCall: getIsAPScall(state.plans),
    isCartOpenClose: getIsCartOpenClose(state.plans),
    cartReturnedPageLinkClicked: getCartReturnedPageLinkClicked(state.plans),
    isCartVariation: variation === SUMMARY_CART_VARIATIONS.CART && getIsCartActive(state.lodgeConfig),
    cartResortLocation: getCartResortLocation(state.cart),
    cartLastVisitedStep: getCartLastVisitedStep(state.cart),
    isCartExpired: getExpiredCart(state.cart),
    adultsCount: getAdultsCount(state.guests),
    kidsAges: getKidsAges(state.guests),
    arrival: getCheckinDateSelection(state.dates),
    departure: getCheckoutDateSelection(state.dates),
    loyaltyEarnThresholdNights: getLoyaltyEarnThresholdNights(state.lodgeConfig),
    kidsCount: getKidsCount(state.guests),
    isHighestRatesEnabled: getIsHighestRatesEnabled(state.lodgeConfig),
    avoidCartLogoRender,
    changeFee: getChangeFee(state.entities.manageReservationDetails),
    isTaxOnlyMessage: getIsTaxOnlyMessage(state.lodgeConfig),
    reservationId: getReservationIdOnAps(state.entities.manageReservationDetails),
    isModifyFlow
  };
};

const mapDispatchToProps = {
  upsertPackage,
  deletePackage,
  clearPlanPackages,
  clearSelectedPackages,
  openModal,
  resetCartResortLocation: resetCartResortLocation,
  pushToLastVisitedStep: pushToLastVisitedStep,
  setExpiredCart: setExpiredCart,
  setIsCartOpenClose,
  setCartReturnedPageLinkClicked,
  clearSelectedSuite,
  pushToPayment,
  pushToDiningPackagesPage,
  pushToPackagesPage,
  updateRateCodes,
  removeActiveOffer
};

const PlanSummary = connect(mapStateToProps, mapDispatchToProps)(Summary);

export { PlanSummary };
